export default __webpack_public_path__ + "static/filewithbluedust-d1382f6226a25382dbf5e0d2295e3a9f.png";